<template>
    <div>
        {{showFinishGame}}
        <v-dialog v-model="$store.state.finishGame" class="animated bounceInDown" persistent max-width="400">
            <v-layout justify-center align-center>
                <v-card class="authenticationCard elevation-12">
                    <v-container>
                        <v-layout>
                            <v-flex>
                                <h1 class="titleFinishGame">{{$t('titleWinGame')}}</h1>
                            </v-flex>
                        </v-layout>
                        <br>
                        <v-layout align-center justify-center>
                            <v-flex>
                                <img class="padronetIcon animated flip" :src="padronetIcon" alt="">
                            </v-flex>
                            <v-flex>
                                <v-layout justify-center>
                                    <v-flex xs12>
                                        <!--                                <div>{{$t('pointsGameText')}}</div>-->
                                        <h2 class="contadorAnswers animated bounceInDown">
                                            +{{pointsCorrectGame - pointsFailedGame}}
                                        </h2>
                                    </v-flex>
                                    <v-flex xs12>
                                        {{$t('pointsText')}}
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12>
                                <v-btn block round dark color="#FF7BA3" class="cardHome"
                                       v-on:click="toRanking()">
                                    <v-layout justify-center align-center>
                                       Consultar ranking
                                    </v-layout>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout justify-center>
                            <v-flex class="classPunts">
                                <div class="classNotaGame animated bounceInDown">
                                    {{notaGame}}%
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-flex class="classPunts">
                            <div class=" animated bounceInDown">
                                {{$t('notaGamteText')}}
                            </div>
                        </v-flex>
                        <br>
                        <v-layout row>
                            <v-flex xs6>
                                <v-btn round color="#FF7BA3" class="cardHome" v-on:click="toHome">
                                    <v-layout>
                                        Aceptar
                                    </v-layout>
                                </v-btn>
                            </v-flex>
                            <v-flex xs6>
                                <v-btn round color="#FF7BA3" class="cardHome" v-on:click="againGame">{{$t('playAgain')}}</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-layout>
        </v-dialog>
        <v-dialog v-model="$store.state.showRanking" persistent max-width="800px">
            <v-layout>
                <v-flex>
                    <RankingFinishGame></RankingFinishGame>
                </v-flex>
            </v-layout>
        </v-dialog>
    </div>
</template>

<script>
    import firebase from 'firebase';
    import {db} from '../firebaseConfig'

    let usersRef = db.ref('Users');


    import Vue from 'vue'
    import VueConfetti from 'vue-confetti'
    import RankingFinishGame from '../components/Ranking'

    import padronetAlegre from '../img/padronet_celebracio_v2_groc_120_x_120_pixels_500_milisegons.gif'
    import padronetaAlegre from '../img/la_padroneta_celebracio_v1_groc_120_x_120_pixels_500_milisegons.gif'

    import {Trans} from '../plugins/Translation'


    Vue.use(VueConfetti);
    export default {
        name: "FinishGame",
        components: {
            RankingFinishGame
        },
        data() {
            return {
                total: 0,
                encertades: 0,
                notaGame: 0,
                counterWinGames: 0,
                username: '',
                contadorEncertades: 0,
                contadorFallades: 0,
                contadorTotalPunts: 0,
                pointsCorrectGame: 0,
                pointsFailedGame: 0,
                padronetIcon: null,
                dialogRanking: false,
            }
        },
        created() {
            this.$store.commit('changeShowRankingFalse');
            let this2 = this;
            //cambiar el padronetx
            firebase.auth().onAuthStateChanged(function (user) {
                usersRef.child(user.uid).child('padronetx')
                    .on('value', function (snap) {
                        if (snap.val() === "1") {
                            this2.padronetIcon = padronetaAlegre

                        } else if (snap.val() === "2") {
                            this2.padronetIcon = padronetAlegre

                        }
                    });
            });
            // control idioma al recarregar
            let lang;
            let path = window.location.pathname;

            if (path === '/jocPadro/cat/board') {
                lang = 'cat';

            } else if (path === '/jocPadro/es/board') {
                lang = 'es';
            }
            const to = this.$router.resolve({params: {lang}});
            return Trans.changeLanguage(lang).then(() => {
                this.$router.push(to.location);
            });
        },
        methods: {
            toHome() {
                this.$router.replace('home');
                this.$store.commit('finishGameFalse');
                this.stop();
            },
            againGame() {
                location.reload();
                this.$store.commit('finishGameFalse');
                this.stop();

                firebase.auth().onAuthStateChanged(function (user) {
                    let updates = {};
                    updates['Users/' + user.uid + '/' + 'pointsCorrectGame'] = 0;
                    updates['Users/' + user.uid + '/' + 'pointsFailedGame'] = 0;
                    updates['Users/' + user.uid + '/' + 'numberCorrectAnswersGame'] = 0;
                    updates['Users/' + user.uid + '/' + 'numberFailedAnswersGame'] = 0;
                    return firebase.database().ref().update(updates);
                });
            },
            showDetails() {
                let this2 = this;
                firebase.auth().onAuthStateChanged(function (user) {

                    usersRef.child(user.uid).child('score').on('value', snap => this2.contadorTotalPunts = snap.val());
                    usersRef.child(user.uid).child('username').on('value', snap => this2.username = snap.val());
                    usersRef.child(user.uid).child('numberCorrectAnswersGame').on('value', snap => this2.contadorEncertades = snap.val());
                    usersRef.child(user.uid).child('numberFailedAnswersGame').on('value', snap => this2.contadorFallades = snap.val());
                    usersRef.child(user.uid).child('pointsCorrectGame').on('value', snap => this2.pointsCorrectGame = snap.val());
                    usersRef.child(user.uid).child('pointsFailedGame').on('value', snap => this2.pointsFailedGame = snap.val());
                });
            },
            start() {
                this.$confetti.start();
                setTimeout(() => {
                    this.love()
                }, 5000);
            },

            stop() {
                this.$confetti.stop();
            },
            love() {
                this.$confetti.update({
                    shape: 'rect',
                    colors: [
                        'SlateBlue',
                        'pink',
                        'gold',
                        'OliveDrab',
                        'pink',
                    ],
                });
            },
            toRanking() {
                this.$store.commit('changeShowRankingTrue');
            }
        },
        computed: {

            showFinishGame() {
                // this.$store.commit('finishGameTrue');
                this.showDetails();
                if (this.$store.state.finishGame === true) {
                    this.start();
                }
                this.total = this.contadorEncertades + this.contadorFallades;
                this.encertades = this.contadorEncertades;
                let total = (this.encertades / this.total) * 100;
                this.notaGame = total.toFixed(0);

            },

        }
    }
</script>

<style lang="scss" scoped>

    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans&display=swap');

    .dialogFinishGame{
        background: #FCE15C;
        padding: 20%;
    }

    .cardHome{
        color: white;
    }

    .classNotaGame {
        font-size: 80px;
    }

    .classPunts {
        display: flex;
        justify-content: center;
    }

    .titleFinishGame {
        text-align: center;
        font-size: 40px;
        font-family: 'Josefin Sans', sans-serif;
        font-weight: bold;
        text-transform: uppercase;
    }


    .padronetIcon {
        position: relative;
        width: 100px;
        height: 100px;
    }

    .authenticationCard {
        z-index: 2;
        background: #43dfd9;
        color: white;
        box-shadow: 0 0 100px black;
        border-radius: 20px;
    }

    .contadorAnswers {
        font-size: 50px;
    }
</style>
